class CartSizeInfo {
  constructor() {
    this.sizeInfoContent();
  }

  sizeInfoContent() {
    document.addEventListener('click', (e) => {
      let that = e.target;
      if (that.classList.contains('info-icon') || that.closest('.info-icon')) {
        let optionWrapper = that.closest(".product-options");
        if (!optionWrapper) {
          optionWrapper = that.closest(".cart-item__details");
        }
        let sizeData = optionWrapper.querySelector('.size-content-data');
        sizeData ? sizeData.classList.add('active') : null;
      } else if (that.classList.contains('close-icon') || that.closest('.close-icon')) {
        let optionWrapper = that.closest(".product-options");
        if (!optionWrapper) {
          optionWrapper = that.closest(".cart-item__details");
        }
        let sizeData = optionWrapper.querySelector('.size-content-data');
        sizeData ? sizeData.classList.remove('active') : null;
      }
    })
  }
}
new CartSizeInfo();
